import { Chart } from './Chart'

class RadialBarChart extends Chart {
  type = 'radialBar'

  options = {
    ...this.options,
    toolbar: {
      show: true,
      tools: {
        download: true
      }
    },
    colors: ['#fab01a'],
    plotOptions: {
      radialBar: {
        startAngle: -135,
        endAngle: 135,
        dataLabels: {
          name: {
            fontSize: '16px',
            color: undefined,
            offsetY: 120
          },
          value: {
            offsetY: 76,
            fontSize: '22px',
            color: undefined,
            formatter: function (val) {
              return `${val}%`
            }
          }
        }
      }
    },
    fill: {
      type: 'gradient',
      gradient: {
        shade: 'dark',
        shadeIntensity: 0.15,
        inverseColors: false,
        opacityFrom: 1,
        opacityTo: 1,
        stops: [0, 50, 65, 91]
      }
    },
    stroke: {
      dashArray: 4
    },
    labels: ['']
  }

  series = []

  setColor(color: string) {
    this.options = {
      ...this.options,
      colors: [color],
      plotOptions: {
        ...this.options.plotOptions,
        radialBar: {
          ...this.options.plotOptions.radialBar,
          dataLabels: {
            ...this.options.plotOptions.radialBar.dataLabels,
            name: {
              ...this.options.plotOptions.radialBar.dataLabels.name,
              color: color
            }
          }
        }
      }
    }
  }
}

export { RadialBarChart }
